// extracted by mini-css-extract-plugin
export default {"container":"K2rF","blockHeader":"hpg8","companyName":"j4t8","actionsWrapper":"tOKj","btn":"gnuG","accept":"VV7a","reject":"OHb9"};